export const DBConfig = {
  name: 'RunAudit',
  version: 2, // Incrementa la versión
  objectStoresMeta: [
    {
      store: 'queries',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'config', keyPath: 'config', options: { unique: false } }, // Corregir keyPath
      ],
    },
  ],
};